module.exports = __webpack_public_path__ + "static/media/sialkot-dark.967b3aeb.svg";